export default __webpack_public_path__ + "static/media/adonai_4.601884b3.jpg";